const prefix = '@kreo-dialog';


export const CLOSE_DIALOG = `${prefix}/CLOSE_DIALOG`;
export const OPEN_DIALOG = `${prefix}/OPEN_DIALOG`;
